function isElementInViewport(el) {
    var rect = el.getBoundingClientRect();
    return (
        rect.bottom > 0 &&
        rect.right > 0 &&
        rect.left < (window.innerWidth || document.documentElement.clientWidth) &&
        rect.top < (window.innerHeight || document.documentElement.clientHeight)
    );
}
function outNum(num, elem, time) {
    const step = 1;
    let e = document.querySelector(elem);
    let n = 0;
    let t = Math.round(time / (num / step));
    let interval = setInterval(() => {
        n = n + step;
        if (n == num) {
            clearInterval(interval);
        }
        e.innerHTML = n;
    }, t);

}

function handleElementAppearance() {
    outNum(338, "#num161", 2000);
    outNum(37, "#num33", 2000);
    outNum(2, "#num2", 2000);
    outNum(51, "#num44", 2000);
}


function onScroll() {
    var yourElement = document.querySelector('.statistics');

    if (isElementInViewport(yourElement)) {
        handleElementAppearance();
        window.removeEventListener("scroll", onScroll);
    }
}

window.addEventListener("scroll", onScroll)
